import React, { useContext, useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';

import { AppContext } from '../contexts/app.context';
import Button from './button';
import GradientStrip from './gradientStrip';

import logo from '../assets/logos/logo.png';
import footerLogo from '../assets/logos/footerLogos.png';

const BaseContainer = () => {
  const {
    baseContainerConfig: {
      heading,
      subHeading,
      buttonText,
      buttonURL,
      buttonCallback,
      showFooter = true,
    } = {},
  } = useContext(AppContext);

  const baseContainerRef = useRef(null);
  const footerRef = useRef(null);

  useEffect(() => {
    if (!showFooter) return;

    const updateFooterPosition = () => {
      const screenHeight = window.innerHeight;
      const baseContainerHeight = baseContainerRef.current.offsetHeight;
      const footerHeight = footerRef.current.offsetHeight;

      if (screenHeight < baseContainerHeight + footerHeight + 100) {
        footerRef.current.style.position = '';
        return;
      }

      footerRef.current.style.position = 'absolute';
      footerRef.current.style.bottom = '0';
      footerRef.current.style.width = '100%';
      footerRef.current.style.left = '0';
      footerRef.current.style.right = '0';
    };

    updateFooterPosition();

    window.addEventListener('resize', updateFooterPosition);

    return () => window.removeEventListener('resize', updateFooterPosition);
  }, [baseContainerRef, footerRef, showFooter, heading, subHeading, buttonText]);

  return (
    <div className="w-full bg-white min-h-dvh">
      <GradientStrip />
      <div ref={baseContainerRef} className="py-20 px-6 sm:px-16 max-w-6xl mx-auto">
        <div className="flex flex-row justify-between items-start flex-wrap gap-6">
          <div className="w-auto flex flex-col items-start gap-2">
            <img src={logo} alt="Logo" className="h-12 w-auto mb-5" />
            {heading && (
              <h1
                className="font-poppins text-4xl font-extrabold text-teal-20"
                dangerouslySetInnerHTML={{ __html: heading }}
              />
            )}
            {subHeading && (
              <p
                className="font-poppins text-lg text-gray-10"
                dangerouslySetInnerHTML={{ __html: subHeading }}
              />
            )}
          </div>
          {buttonText && <Button text={buttonText} url={buttonURL} callback={buttonCallback} />}
        </div>
        <div className="mt-12">
          <Outlet />
        </div>
      </div>

      {showFooter && (
        <div
          ref={footerRef}
          style={{ display: showFooter ? 'flex' : 'none' }}
          className="flex items-center justify-center p-6 mt-16 border-t border-black bg-gray-70">
          <img src={footerLogo} alt="Footer Logo" className="h-20 w-auto" />
        </div>
      )}
    </div>
  );
};

export default BaseContainer;
